import { InjectionToken } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Browser window', {
	providedIn: 'root',
	factory: (): Window => window
});

export const DOCUMENT = new InjectionToken<Document>('Browser document', {
	providedIn: 'root',
	factory: (): Document => document
});

export const BROWSER_STORAGE = new InjectionToken<Storage>('Browser Storage', {
	providedIn: 'root',
	factory: (): Storage => localStorage
});
